<div>
    <app-form-input
    [parentForm]="parentForm"

    [label]="''"
    [type]="'radio'" [rule]="''"
    [value]="radioButtonValue1"
    [name]="getUid() + '_SepAtt_RB'"
    [radios]="[
            {
                value: '',
                label: step4.getspan6
            },
            {
                value: null,
                label: step4.getspan8
            }]"
    >
    </app-form-input>
</div>

<div *ngIf="rbValue()">
    <app-form-input [parentForm]="parentForm"
    [disabled]="disabled"
    [value]="infosRectif.rubDelais"
    [label]="step4.getrubdelais"
    [type]="'select'"
[typeSelect]="optionsSelectType"
    [optionsWithCode]="optionsSelect"
    [rule]="'required|pattern_35'"
    [errorMessage]="{'required' : 'ctr_459'}"
    [name]="getUid()+'_SepAtt_rubDelais'">
    </app-form-input>

   
    <app-form-input
    [parentForm]="parentForm"
    [value]="infosRectif.auLieuDeDate"

    [label]="step4.getspan7"
    [type]="'datetime'" 
    [name]="getUid()+'_SepAtt_auLieuDeDate'">
    </app-form-input>

    <app-form-input
    [parentForm]="parentForm"
    [value]="infosRectif.lireDate"

    [label]="step4.getliredate"
    [type]="'datetime'" [rule]="'required'"
    [errorMessage]="{'required' : 'ctr_458'}"
    [name]="getUid()+'_SepAtt_lireDate'">
    </app-form-input>
</div>

<div *ngIf="!rbValue()">
    <app-form-input
    [parentForm]="parentForm"
    [value]="infosRectif.rubrique"

    [label]="step4.getrubrique"
    [type]="'text'" [rule]="'minSize_1|maxSize_255'"
    [name]="getUid()+'_SepAtt_rubrique'">
    </app-form-input>

    <app-form-input
    [parentForm]="parentForm"

    [label]="''"
    [type]="'radio'" [rule]="''"
    [value]="infosRectif.isALS"
    [name]="radioButtonCtrlName"
    [radios]="[
            {
                value: lire,
                label: step4.getlire
            },
            {
                value: ajouter,
                label: step4.getajouter
            },
            {
                value: supprimer,
                label: step4.getsupprimer
            }]"
    >
    </app-form-input>

    <app-form-input *ngIf="alsValue()===ajouter || alsValue()===supprimer"
    [parentForm]="parentForm"
    [value]="infosRectif.apresLaMention"

    [label]="step4.getapreslamention"
    [type]="'text'" [rule]="'minSize_5|maxSize_2000'"
    [errorMessage]="{'minLength' : 'ctr_1159'}"
    [name]="getUid()+'_SepAtt_apresLaMention'">
    </app-form-input>

    <app-form-input *ngIf="alsValue()===ajouter"
    [parentForm]="parentForm"
    [value]="infosRectif.ajouter"

    [label]="step4.getajouter"
    [type]="'text'" [rule]="'required|minSize_5|maxSize_2000'"
    [errorMessage]="{'required' : 'ctr_455', 'minLength' : 'ctr_1158'}"
    [name]="getUid()+'_SepAtt_ajouter'">
    </app-form-input>

    <app-form-input *ngIf="alsValue()===lire"
    [parentForm]="parentForm"
    [value]="infosRectif.auLieuDe"

    [label]="step4.getaulieude"
    [type]="'text'" [rule]="'minSize_5|maxSize_2000'"
    [errorMessage]="{'minLength' : 'ctr_1157'}"
    [name]="getUid()+'_SepAtt_auLieuDe'">
    </app-form-input>

    <app-form-input *ngIf="alsValue()===lire"
    [parentForm]="parentForm"
    [value]="infosRectif.lire"

    [label]="step4.getlire"
    [type]="'text'" [rule]="'required|minSize_5|maxSize_2000'"
    [errorMessage]="{'required' : 'ctr_455', 'minLength' : 'ctr_1158'}"
    [name]="getUid()+'_SepAtt_lire'">
    </app-form-input>


    <app-form-input *ngIf="alsValue()===supprimer"
    [parentForm]="parentForm"
    [value]="infosRectif.supprimer"

    [label]="step4.getsupprimer"
    [type]="'text'" [rule]="'required|minSize_5|maxSize_2000'"
    [errorMessage]="{'minLength' : 'ctr_1158'}"
    [name]="getUid()+'_SepAtt_supprimer'">
    </app-form-input>
</div>
<!--app-form-input-error *ngIf="delai() && auLieuDe()" [activeForm]="parentForm" [name]="rg1"></app-form-input-error-->
